import type { Feedback, FeedbackKind } from "./support-client";

/**
 * The helpdesk has no category field, so the first line is what the team
 * filters and tags on. Change a label only together with any workflow that
 * matches it.
 */
const KIND_LABELS: Record<FeedbackKind, string> = {
  bug: "Bug report",
  feature: "Feature request",
  other: "Other feedback",
};

/** A line break in a value would start a header line of its own. */
function oneLine(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

/**
 * A short header, a blank line, then the attorney's words as written. The
 * helpdesk takes text only, so the header is where the context has to go.
 */
export function formatFeedbackMessage(feedback: Feedback): string {
  return [
    `Type: ${KIND_LABELS[feedback.kind]}`,
    `Browser: ${oneLine(feedback.browser)}`,
    `Device OS: ${oneLine(feedback.os)}`,
    `Screen: ${oneLine(feedback.screen)}`,
    "",
    feedback.text.trim(),
  ].join("\n");
}
